/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const common = {
  common: {
    cancel: 'Cancelar',
    delete: 'Apagar',
    remove: 'Eliminar',
    edit: 'Editar',
    restore: 'Restaurar',
    back: 'Atrás',
    submit: 'Enviar',
    continue: 'Continuar',
    save: 'Salvar',
    done: 'Fato',
    home: 'Inicio',
    noData: 'Não há dados.',
    confirm: 'Confirmar',
    mais: 'mais',
    close: 'Datar',
    loading: 'Carga',
    menu: 'Menu',
    reset: 'Repor',
    search: 'Achar',
    add: 'Adicionar',
    breadcrumbs: 'Farinha de rosca',
    selectFile: 'Selecione o arquivo',
    clear: 'É claro',
    loaded: 'É claro',
    results: 'Resultados',
    of: 'de',
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} resultado para {{{query}}',
      title_other: '{{count}} Resultados para {{{query}}',
    },
    checkout: {
      title: 'Caixa',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_other: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_other: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'Todos os produtos',
    },
    product: {
      description: '{{{description}}',
      heading: '{{{heading}}',
      title: '{{{title}}',
    },
  },
  spinner: {
    loading: 'Carga...',
  },
  navigation: {
    categoryNavLabel: 'Menu de categorias',
    footerNavLabel: 'Links de rodapé',
    navigateTo: 'Navegue até {{{nav}}',
    scrollToTop: 'Role de volta para o topo da página',
  },
  searchBox: {
    placeholder: 'Insira o nome ou código do produto',
    productAchar: 'Comprando um produto',
    ariaLabelInput: 'Aquí area...',
    ariaLabelSuggestions: 'Sugestões de digitação',
    ariaLabelProducts: 'Resultados do produto',
    initialDescription:
      'Quando os resultados do preenchimento automático estiverem disponíveis, use as setas para cima e para baixo para revisar e insira para selecionar. Os usuários de toque podem explorar por toque ou com gestos de deslizar.',
    suggestionsResult: '{{ count }} sugestão e ',
    suggestionsResult_other: '{{ count }} sugestões e ',
    productsResult: '{{ count }} O produto está disponível.',
    productsResult_other: '{{ count }} Os produtos estão disponíveis.',
    resetLabel: 'Repor Achar',
    help: {
      insufficientChars: 'Por favor, escriba mais caracteres',
      noMatch: 'Nenhum resultado foi encontrado',
      exactMatch: '{{ term }}',
      empty: 'Pergunte-nos o que quiser',
    },
  },
  sorting: {
    date: 'Data',
    orderNumber: 'Número do pedido',
    rma: 'Número de devolução',
    replenishmentNumber: 'Número de substituição',
    nextOrderData: 'Dados do próximo pedido',
    pageViewUpdated: 'A visualização de página foi atualizada com as opções selecionadas.',
  },
  httpHandlers: {
    badRequest: {
      bad_credentials: 'Credenciais erradas. Faça login novamente.',
      user_is_disabled: 'O usuário está desabilitado. Gerenciamento de contatos.',
    },
    badGateway: 'Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.',
    badRequestPleaseLoginAgain: '{{ errorMessage }}. Faça login novamente.',
    badRequestOldPasswordIncorrect: 'A senha antiga está incorreta.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} e-mail já existem. Por favor, faça o check-out com um e-mail diferente para se inscrever em uma conta de convidado.',
    conflict: 'Já existe.',
    forbidden:
      'Você não está autorizado a tomar esta ação. Entre em contato com o administrador se achar que isso é um erro.',
    gatewayTimeout: 'O servidor não respondeu, tente novamente mais tarde.',
    internalServerError:
      'Ocorreu um erro interno do servidor. Por favor, tente novamente mais tarde.',
    sessionExpired: 'Sua sessão expirou. Faça login novamente.',
    unknownError: 'Ocorreu um erro desconhecido',
    unauthorized: {
      common: 'Ocorreu um erro de autorização desconhecido',
      invalid_client: 'Credenciais de cliente incorretas',
    },
    validationErrors: {
      missing: {
        card_cardType:
          'O cartão de crédito selecionado não é suportado. Selecione outro.',
        card_accountNumber: 'O número do cartão de crédito inserido é inválido.',
        card_cvNumber: 'O código de segurança inserido é inválido.',
        card_expirationMonth:
          'A data de validade do cartão de crédito inserido é inválida.',
        card_expirationYear:
          'A data de validade do cartão de crédito inserido é inválida.',
        billTo_firstName: 'O nome inserido é inválido.',
        billTo_lastName: 'O sobrenome inserido é inválido.',
        billTo_street1: 'O endereço inserido é inválido.',
        billTo_street2: 'O endereço inserido é inválido.',
        billTo_city: 'A cidade indicada não é válida para este cartão de crédito.',
        billTo_state:
          'The state/province entered is not valid for this credit card.',
        billTo_country:
          'The country/region entered is not valid for this credit card.',
        billTo_postalCode:
          'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Faltando país/região',
        },
      },
      invalid: {
        card_expirationMonth:
          'A data de validade do cartão de crédito inserido é inválida.',
        firstName: 'O nome inserido é inválido.',
        lastName: 'O sobrenome inserido é inválido.',
        password: 'A senha digitada é inválida.',
        uid: 'O UID é inválido.',
        code: 'O código é inválido.',
        email: 'O e-mail é inválido.',
      },
    },
    cartNotFound: 'Carrinho não encontrado.',
    invalidCodeProvided: 'Um código inválido foi fornecido.',
    voucherExceeded:
      'Este cupom excedeu o número de vezes que pode ser usado',
    unknownIdentifier: 'Item não encontrado.',
    otherCartErrors: 'Ocorreram erros no carrinho.',
  },
  miniCart: {
    item: '{{count}} Item atualmente no seu carrinho',
    item_other: '{{count}} Itens atualmente no seu carrinho',
    total: '{{total}}',
    count: '{{count}}',
    entries: 'Itens'
  },
  skipLink: {
    skipTo: 'Pule para',
    labels: {
      header: 'Cabeçalho',
      main: 'Conteúdo principal',
      footer: 'Rodapé',
      productFacets: 'Facetas do produto',
      productList: 'Lista de Produtos',
    },
  },
  carousel: {
    previousSlide: 'Slide anterior',
    nextSlide: 'Próximo slide',
    slideNumber: 'Slide {{{currentSlideNumber}}',
    carouselForProduct: 'Carrossel, Imagens para {{{product}}',
  },
  formErrors: {
    globalMessage: 'O formulário que você está tentando enviar contém erros.',
    required: 'Este campo é obrigatório',
    cxInvalidEmail: 'Este não é um formato de e-mail válido',
    cxInvalidPassword: 'Este não é um formato de senha válido',
    cxPasswordsMustMatch: 'Os campos de senha devem corresponder',
    cxEmailsMustMatch: 'Os campos de e-mail devem corresponder',
    cxStarRatingEmpty: 'O campo de classificação é obrigatório',
    cxNoSelectedItemToCancelar: 'Selecione pelo menos um item',
    cxNegativeAmount: 'O valor deve ser igual ou maior que zero',
    cxContainsSpecialCharacters: 'O campo não pode conter caracteres especiais',
    date: {
      required: 'Este campo é obrigatório',
      min: 'A data não pode ser anterior a {{{min}}',
      max: 'A data não pode ser posterior a {{{max}}',
      pattern: 'Usar o formato de data aaaa-mm-dd',
      invalid: 'Use uma data válida',
    },
    file: {
      required: 'Um arquivo é necessário',
      empty: 'O arquivo não deve estar vazio',
      invalidExtension: 'A extensão do arquivo é inválida',
      tooLarge: 'O tamanho do arquivo não deve exceder {{ maxSize }} MB',
      tooManyEntries: 'O número de artigos é maior que {{ maxEntries }}',
      notParsable: 'O arquivo não pode ser verificado',
      fileNotAllowed: 'Este tipo de arquivo não é permitido',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'O script não pôde ser carregado.',
    refreshThePage: 'Por favor, atualize a página.',
  },
  assistiveMessage: {
    actionCancelarled: 'Ação cancelada, nada alterado',
  },
  passwordVisibility: {
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
  },
  generalErrors: {
    pageFailure: 'A página não pôde ser carregada. Por favor, tente novamente mais tarde.',
  },
  chatMessaging: {
    charactersLeft: 'Caracteres à esquerda: {{count}}',
    addNewMessage: 'Adicionar nova mensagem',
    send: 'Enviar',
    uploadFile: 'Carregar arquivo',
    informationLabel: '{{{author}}. {{{text}} em {{{date}}',
    messages: 'Mensagens',
    addMessagePlaceHolder: 'Comece a escrever...',
    characterLimitAlert: 'O limite de caracteres foi atingido.',
  },
};
